const selectboxItems = ['MDRD', 'CKD-EPI'];
const genderItems = [
  { value: 1, label: 'Male' },
  { value: 0, label: 'Female' }
];

const booleanItems = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

const smokeDurationItems = [
  { label: 'Unknown', value: 1 },
  { label: 'Less than 6 months ago', value: 2 },
  { label: '6 months _ 1.5 years ago', value: 3 },
  { label: '1.5 _ 2.5 years ago', value: 4 },
  { label: '2.5 _ 3.5 years ago', value: 5 },
  { label: '3.5 _ 5 years ago', value: 6 },
  { label: 'more than 5 years ago', value: 7 }
];

const smokerItems = [
  { label: 'Current', value: 0 },
  { label: 'Former', value: 1 },
  { label: 'Never', value: 2 }
];

export {
  smokerItems,
  genderItems,
  selectboxItems,
  booleanItems,
  smokeDurationItems
};
